import { intlLocale } from '../../lib/datetime'

/** TRY para biçimlendirici — dile göre cache'li (her render'da yeniden kurulmaz; tek kaynak). */
const cache: Record<string, Intl.NumberFormat> = {}

export function tryCurrency(lang: string): Intl.NumberFormat {
  // Intl locale tek kaynaktan (intlLocale): 'en' → en-GB. TRY için sayı biçimi en-US ile aynı; tutarlılık için ortak.
  const locale = intlLocale(lang)
  return (cache[locale] ??= new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'TRY',
    maximumFractionDigits: 0,
  }))
}
